import { Listbox } from "@headlessui/react";
import Tooltip, { TooltipProps } from "@/components/UI/Tooltip";
import ListItem, { ListItemProps, ListItemSize } from "@/components/UI/List/ListItem";
import { Fragment } from "react";

// See: https://tailwindui.com/components/application-ui/forms/select-menus
// See: https://headlessui.com/react/listbox

type ListboxOptionProps = Parameters<typeof Listbox.Option>[0];

export type SelectOptionProps = ListboxOptionProps & {
  children?: React.ReactNode;
  listItemProps?: ListItemProps;
  size?: keyof typeof ListItemSize;
  tooltipProps?: TooltipProps;
};

export const SelectOption = ({
  children,
  className,
  listItemProps,
  size = ListItemSize.medium,
  tooltipProps,
  ...props
}: SelectOptionProps) => {
  return (
    <Tooltip {...tooltipProps}>
      <Listbox.Option as={Fragment} {...props}>
        {(renderProps) => {
          return (
            <ListItem active={renderProps.selected} disabled={renderProps.disabled} size={size} {...listItemProps}>
              {children}
            </ListItem>
          );
        }}
      </Listbox.Option>
    </Tooltip>
  );
};

export default SelectOption;
